// ---------------- logos ------------------
import logo from "../assets/logos/black_logo.png";
import Forbes_logo from "../assets/logos/Forbes_logo.png";
import NBC_logo from "../assets/logos/NBC_logo.png";
import fox_logo from "../assets/logos/fox_logo.png";
import wsj_logo from "../assets/logos/wsj_logo.png";
import yahoo_logo from "../assets/logos/yahoo_logo.png";
import The_New_York_Times_logo from "../assets/logos/The_New_York_Times_logo.png";

import american from "../assets/logos/american.svg";
import master from "../assets/logos/master.svg";
import jcb from "../assets/logos/jcb.svg";
import visa from "../assets/logos/visa.svg";
import treat_med from "../assets/logos/med.png";
import treat_lock from "../assets/logos/lock.png";
import treat_doctor from "../assets/logos/doctor.png";

// ---------------- images ------------------

import bottel_img from "../assets/logos/bottel_img.png";


export default {
  // ---------------- logos ------------------
  logo,
  Forbes_logo,
  NBC_logo,
  fox_logo,
  wsj_logo,
  yahoo_logo,
  The_New_York_Times_logo,

  visa,
  master,
  jcb,
  american,

  treat_doctor,
  treat_lock,
  treat_med,
  bottel_img,
};
